module.exports = __webpack_public_path__ + "static/srikanthan-photo-3976aec8c611c509775e3e6b8b95675d.jpg";